import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            base62Id,
            allowComment,
            joinNum,
            count,
            noffhFlag,
            title,
            newsTime,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            breadCrumbdata,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const props =
            !fhhAccountDetail.forbidJump && fhhAccountDetail.authorUrl
                ? {
                      href: fhhAccountDetail.authorUrl,
                      target: '_blank',
                  }
                : {};

        return (
            <div>
                <div className={styles.breadcrumbs}>
                    {breadCrumbdata.map((item, index) => (
                        <span key={index}>
                            <a href={item.url}>{item.title}</a>
                            {' > '}
                        </span>
                    ))}
                    <span>正文</span>
                </div>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <p className={styles.time}>
                        <span className={styles.date}>{newsTime}</span>
                        <br />
                        <span style={{ verticalAlign: 'bottom' }}>{fhhAccountDetail.catename ? '来源：' : ''}</span>
                        <span className={styles.publisher}>
                            {!fhhAccountDetail.catename ? (
                                <span className={styles.source}>
                                    {fhhAccountDetail.authorUrl ? (
                                        <a href={fhhAccountDetail.authorUrl} target="_blank">
                                            {fhhAccountDetail.catename}
                                        </a>
                                    ) : (
                                        <span className={styles.txt}>{fhhAccountDetail.catename}</span>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.source}>
                                    {noffhFlag ? (
                                        <a>{fhhAccountDetail.catename}</a>
                                    ) : (
                                        <a {...props}>{fhhAccountDetail.catename}</a>
                                    )}
                                </span>
                            )}
                        </span>
                    </p>
                    <div className={styles.share_box}>
                        <ContentShare shareInfo={shareInfo} />
                    </div>
                    {allowComment ? (
                        <div className={styles.comment_box}>
                            <h5 className={styles.comment}>
                                <a
                                    className={styles.joinNum}
                                    href={`http://gentie.ifeng.com/c/comment/${base62Id}`}
                                    target="_blank">
                                    <span className={styles.num}>{joinNum}</span>
                                    <span className={styles.text}>人参与</span>
                                </a>
                                <a
                                    className={styles.commentNum}
                                    href={`http://gentie.ifeng.com/c/comment/${base62Id}`}
                                    target="_blank">
                                    <span className={styles.num}>{count}</span>
                                    <span className={styles.text}>评论</span>
                                </a>
                            </h5>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
